<template>
  <div
    class="draft-card py-4 px-5"
    :class="enable ? 'bg-positive-024' : 'bg-alert-024'"
  >
    <div
      class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-5"
    >
      <span :class="enable ? 'text-positive-500' : 'text-alert-500'">
        {{
          enable
            ? "A configuração necessária foi realizada, solicite ao suporte a aprovação do seu produto."
            : "Finalize as configurações necessárias para seguir com a solicitação de aprovação do seu produto."
        }}
      </span>

      <bp-button
        size="md"
        variant="outlined-1"
        label="Solicitar aprovação"
        :disabled="!enable"
        @click="requestApproval"
      />
    </div>
  </div>
</template>

<script>
import { approvalMessageUrl } from "@/functions/product";
export default {
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    enable: Boolean
  },
  methods: {
    requestApproval() {
      window.open(approvalMessageUrl(this.product, this.$user.user), "_blank");
    }
  }
};
</script>
